import React from 'react'
import '../subComponents/Loader.css'

function Loader(props) {
    const style = {};
    if (props.size) {
        style['--loader-size'] = `${props.size}px`;
    }
    if (props.borderWidth) {
        style['--loader-border-width'] = `${props.borderWidth}px`;
    }
    return (
        <div className={`lds-dual-ring ${props.colored ? 'colored' : ''}`} style={style}></div>
    )
}
export default Loader
